<template>
  <div
    v-if="shouldRenderConfig && !getBundleIsActive"
    v-show="getMatrixComplete"
    :class="getClassName"
  >
    <button type="button" class="btn btn-primary" @click="onClickBack()">
      {{ $t("Back to configuration") }}
    </button>
  </div>
</template>
<script>
import { useConfigStore } from "@/stores/modules/config";
import { useBundleStore } from "@/stores/modules/bundle";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(useBundleStore, ["getBundleIsActive"]),
    ...mapState(useConfigStore, ["getMatrixComplete"])
  },
  methods: {
    ...mapActions(useConfigStore, ["setMatrixComplete"]),
    onClickBack: function () {
      this.setMatrixComplete(!this.getMatrixComplete);
    }
  }
};
</script>
